module.exports = __webpack_public_path__ + "img/facebookIcon.08d03270.svg";